import { RecognizeAudienceProduct } from "@redotech/redo-recognize-common/audience-product";
import * as z from "zod";

export const searchRecognizeAudienceProducts = {
  name: "searchRecognizeAudienceProducts" as const,
  input: z.object({ search: z.string().max(200) }),
  output: z.array(RecognizeAudienceProduct.extend({ title: z.string() })),
};
